<template>
  <div id="wrap">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { DEVICE_TYPE } from "@/utils/Constants";
import GdsApi from "@/config/api/gds.js";

export default {
  name: "App",
  computed: {
    ...mapGetters(["clientInfo", "getDeviceType", "getServiceAuthInfo", "getMypageToken"]),
    getBrowserLanguage() {
      return navigator.language || navigator.userLanguage;
    }
  },
  created() {
    this.$store.commit("SETTING_SERVICE_INFO");
    if (this.getDeviceType === DEVICE_TYPE.IOS) {
      // ios 애플 로그인 가능여부 세팅
      const urlSearch = new URLSearchParams(location.search);
      const enableSignInWithApple = urlSearch.get("enableSignInWithApple");

      if (typeof enableSignInWithApple !== "undefined" && enableSignInWithApple !== null) {
        this.$store.commit("SETTING_ENABLED_APPLE_SIGNIN", enableSignInWithApple.toLowerCase());
      }
    }

    console.log(`Membership v-1.6.9(2)`);

    //mypage token 세팅
    this.settingMypageToken();

    //다국어를 위한 gds api 호출
    // this.getGdsInfo();
  },
  mounted() {
    window.Kakao.init(this.clientInfo.KAKAO_SECRET_KEY);
  },
  methods: {
    getGdsInfo() {
      const param = {
        policy_group: "web",
        device_country: "KR", //ip주소 국가 정보 획득 실패 시 2차적 사용되는 국가코드 정보
        client_lang: this.getBrowserLanguage, //client 언어설정을 따름, 브라우저 설정언어
        include_coverages: true
      };
      GdsApi.getGdsPolicyTotal(param, null).then((response) => {
        if (typeof response === "undefined") return;
        const data = response.data;
        const code = data.code;

        if (code === 0) {
          this.chnageLangauge(data.value.lang);
        }
      });
    },
    chnageLangauge(lang) {
      this.$i18n.locale = lang;
    },
    settingMypageToken() {
      const hasMypageAuth = this.$route.meta.hasMypageAuthCheck;

      // 마이페이지 권한체크
      const reffer = document.referrer;
      const isDivcePc = this.getDeviceType === DEVICE_TYPE.PC; //pc에서만 체크

      if (typeof reffer === "undefined" || reffer === "") {
        this.$store.commit("INIT_MYPAGE_TOKEN");
        return;
      }

      if (hasMypageAuth && isDivcePc) {
        const authToken = this.getServiceAuthInfo.access_token;
        const mypageToken = this.getMypageToken.access_token;

        if (authToken === "" && mypageToken !== "") {
          const mypageRefreshToken = this.getMypageToken.refresh_token;
          //api 호출시 토큰 검증 오류가 발생하기 때문에 별도 검증은 하지 않는다
          const token = {
            access_token: mypageToken,
            refresh_token: mypageRefreshToken
          };

          this.$store.commit("CHANGE_LOGIN_STATE", token);
        }
      }
    }
  }
};
</script>
